import { Provider } from '@angular/core';
import { TagDomainService } from '@app/domain/services';
import {
  GetTagsUseCase,
  GetTagUsageCountsUseCase,
  GetTagByIdUseCase,
  CreateTagUseCase,
  UpdateTagUseCase,
  DeleteTagUseCase,
} from '@app/domain/use-cases';
import type { ITagRepository } from '@app/domain/ports';
import { TAG_REPOSITORY } from '../../tokens/infrastructure.tokens';

export function provideTagDomain(): Provider[] {
  return [
    {
      provide: TagDomainService,
      useFactory: (repository: ITagRepository) => new TagDomainService(repository),
      deps: [TAG_REPOSITORY],
    },
    {
      provide: GetTagsUseCase,
      useFactory: (repository: ITagRepository) => new GetTagsUseCase(repository),
      deps: [TAG_REPOSITORY],
    },
    {
      provide: GetTagUsageCountsUseCase,
      useFactory: (repository: ITagRepository) => new GetTagUsageCountsUseCase(repository),
      deps: [TAG_REPOSITORY],
    },
    {
      provide: GetTagByIdUseCase,
      useFactory: (repository: ITagRepository) => new GetTagByIdUseCase(repository),
      deps: [TAG_REPOSITORY],
    },
    {
      provide: CreateTagUseCase,
      useFactory: (repository: ITagRepository, domainService: TagDomainService) =>
        new CreateTagUseCase(repository, domainService),
      deps: [TAG_REPOSITORY, TagDomainService],
    },
    {
      provide: UpdateTagUseCase,
      useFactory: (repository: ITagRepository, domainService: TagDomainService) =>
        new UpdateTagUseCase(repository, domainService),
      deps: [TAG_REPOSITORY, TagDomainService],
    },
    {
      provide: DeleteTagUseCase,
      useFactory: (repository: ITagRepository) => new DeleteTagUseCase(repository),
      deps: [TAG_REPOSITORY],
    },
  ];
}
